import { FC } from "react";

import Box, { BoxProps } from "@mui/material/Box";

import Heading from "sections/nfcTagsPage/Heading";
import AppItemSection from "sections/nfcTagsPage/AppItemSection";

import ImageNext from "components/ImageNext";

import styles from "./styles";

const ITEMS = [
  {
    label: "Improve your upselling",
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/app/0.png`,
  },
  {
    label: "Send exclusive news to your NFT owners",
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/app/1.png`,
  },
  {
    label: "Recommend matching items to your clients",
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/app/2.png`,
  },
  {
    label: "Let your customers be your ambassadors",
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/app/3.png`,
  },
  {
    label: "Build community around your brand",
    image: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/app/4.png`,
  },
];

interface AppSectionProps {
  boxProps?: BoxProps;
}

const AppSection: FC<AppSectionProps> = ({ boxProps }) => {
  return (
    <Box component="section" display="grid" {...boxProps}>
      <Heading
        heading="Real-world application"
        subheading="Send tickets to nft owners of your goods. If they own an item from your brand, they can get the tickets directly to their nfc label on the clothing."
      />

      <Box sx={styles.contentWrapper}>
        <Box sx={styles.itemsWrapper}>
          {ITEMS.map((item, index) => (
            <AppItemSection key={index} image={item.image} label={item.label} />
          ))}
        </Box>

        <Box sx={styles.imageWrapper}>
          <ImageNext
            src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/app/scan.png`}
            width={491}
            height={375}
            alt=""
            style={{
              width: "100%",
              maxWidth: 500,
              objectFit: "contain",
              height: "auto",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default AppSection;
